import firebase from 'firebase/compat/app';
import {initializeApp} from 'firebase/app';

export const setupProject = function (firebaseCreds) {
  initializeApp(firebaseCreds);
  // // console.log(firebaseCreds)
  return firebase.initializeApp(firebaseCreds);
};
